import { Autocomplete } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { BoxComponent } from 'src/components/common/BoxComponent';
import { ButtonComponent } from 'src/components/common/ButtonComponent';
import { GridComponent } from 'src/components/common/GridComponent';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { StackComponent } from 'src/components/common/StackComponent';
import { useAllAssigneesQuery } from 'src/services/Utils';
import { useRaiseQuery } from './useRaiseQuery';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export const RaiseQuery: React.FunctionComponent<any> = ({
  queryKeys,
  queryType,
  openRaiseQuery,
  setOpenRaiseQuery,
  getSivReportQueries,
  report_id,
  reportQueryId,
  prevAssign,
  fieldQueries,
  forwardQueryId
}) => {
  const { handleClosenew, handleChange, handleMsgChange, sendFieldQuery, validationObj, errorText, sendTo, msg } =
    useRaiseQuery(
      setOpenRaiseQuery,
      queryKeys,
      queryType,
      getSivReportQueries,
      report_id,
      reportQueryId,
      prevAssign,
      fieldQueries,
      forwardQueryId
    );
  const [userList, setUserList] = useState<any>([]);
  const { isSuccess: allAssigneesIsSuccess, data: allAssigneesData } = useAllAssigneesQuery();

  useEffect(() => {
    if (allAssigneesIsSuccess && allAssigneesData) {
      const user = allAssigneesData.map((ele: any) => {
        return {
          displayName: `${ele.firstName} ${ele.lastName} (${ele.email})`,
          key: `${ele.firstName} ${ele.lastName}`
        };
      });
      setUserList([...user]);
    }
  }, [allAssigneesData, allAssigneesIsSuccess]);

  return (
    <div className="modal-view">
      <PopupComponent
        aria-labelledby="customized-dialog-title"
        open={openRaiseQuery}
        className="raisefield-modal"
        child
      >
        <Loader />
        <DialogContent className="audit-history-modal">
          <div className="audit-card sivreport-audit-history">
            <GridComponent container spacing={0}>
              <GridComponent md={12}>
                <BoxComponent sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', pt: 0 }}>
                  <GridComponent container>
                    <GridComponent container>
                      <GridComponent item md={12}>
                        <h2 style={{ marginBottom: '16px' }}>
                          {queryType === 'Forward'
                            ? 'Forward Query'
                            : queryType !== '' && queryType !== null && queryType !== undefined
                            ? // ? 'Raise' + ' ' + queryType + ' ' + 'Query'
                              'Raise Query'
                            : 'Raise Query'}
                        </h2>
                      </GridComponent>
                    </GridComponent>

                    <GridComponent container spacing={0}>
                      <GridComponent item md={12}>
                        <FormControl variant="standard" fullWidth>
                          <Autocomplete
                            id="controlled-demo"
                            value={sendTo}
                            onChange={(event: any, newValue: any) => {
                              handleChange(newValue);
                            }}
                            options={userList.map((ele: any) => ele.displayName)}
                            renderInput={params => (
                              <TextField
                                {...params}
                                label={queryType === 'Forward' ? 'Forward To' : 'Send To'}
                                variant="standard"
                              />
                            )}
                          />
                        </FormControl>
                      </GridComponent>
                      <GridComponent md={12} mt={1}>
                        <BoxComponent
                          component="div"
                          /* sx={{
                            '& > :not(style)': { m: 1, minWidth: 308 }
                          }} */
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            error={validationObj.report_comment}
                            helperText={validationObj.report_comment ? errorText : ''}
                            id="report_comment"
                            label="Message"
                            multiline
                            maxRows={4}
                            required
                            fullWidth
                            variant="standard"
                            value={msg}
                            inputProps={{ maxLength: 200 }}
                            onChange={handleMsgChange}
                            onKeyDown={e => {
                              e.stopPropagation();
                            }}
                            name="report_comment"
                          />
                        </BoxComponent>
                      </GridComponent>
                    </GridComponent>
                  </GridComponent>
                </BoxComponent>
              </GridComponent>
            </GridComponent>
          </div>
        </DialogContent>
        <DialogActions>
          <StackComponent direction="row" spacing={2}>
            <ButtonComponent variant="text" className="grey-btn" onClick={handleClosenew}>
              Cancel
            </ButtonComponent>
            <ButtonComponent variant="text" onClick={sendFieldQuery}>
              Submit
            </ButtonComponent>
          </StackComponent>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};
